import { useEffect, useState } from "react";

/** 即时跳转到指定板块：目标板块顶部与屏幕顶部重叠，不做滚动动画 */
export function hdmgdjJumpTo(id: string): void {
  if (typeof document === "undefined") {
    return;
  }
  const el = document.getElementById(id);
  if (!el) {
    return;
  }
  const top = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
  try {
    window.scrollTo(0, top);
  } catch {
    el.scrollIntoView();
  }
}

/**
 * 页头状态：
 * - scrolled：已离开首屏 → 页头收起为实色（否则悬浮在深色主视觉之上，保持通透）
 * - hidden：下滚隐藏、上滚显示，避免固定页头挡住板块顶部
 */
export function useHdmgdjHeader(): { hidden: boolean; scrolled: boolean } {
  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    let ticking = false;

    const handle = () => {
      if (ticking) {
        return;
      }
      ticking = true;
      const run = () => {
        const y = window.pageYOffset || document.documentElement.scrollTop || 0;
        setScrolled(y > 32);
        const delta = y - lastY;
        if (Math.abs(delta) > 6) {
          if (y > 140 && delta > 0) {
            setHidden(true);
          } else {
            setHidden(false);
          }
          lastY = y;
        }
        ticking = false;
      };
      if (typeof window.requestAnimationFrame === "function") {
        window.requestAnimationFrame(run);
      } else {
        run();
      }
    };

    handle();
    window.addEventListener("scroll", handle, { passive: true });
    return () => window.removeEventListener("scroll", handle);
  }, []);

  return { hidden, scrolled };
}

/**
 * 入场动效现由纯 CSS 完成（元素基态始终可见）。
 * 这里刻意不再用 JS 给任何元素加「隐藏」类，
 * 从根本上杜绝 iOS / 老内核上元素被隐藏后不再显示（闪一下消失）的问题。
 */
export function useHdmgdjReveal(): void {
  // no-op：保留导出以兼容既有调用，实际不做任何隐藏操作
}